import { render, staticRenderFns } from "./AvatarBody.vue?vue&type=template&id=06cb1dcc&"
import script from "./AvatarBody.vue?vue&type=script&lang=js&"
export * from "./AvatarBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports